import { formatTextForDisplay } from '@src/shared/utils/helpers/format-text-for-display';
import { PAYMENT_METHODS } from '@src/shared/types/payment-method';
import { createSimpleFilterConfig } from '../factories/create-simple-filter-config';

export const paymentMethodFilterConfig = createSimpleFilterConfig({
  facetName: 'method',
  options: Object.values(PAYMENT_METHODS).map((method) => ({
    label: formatTextForDisplay(method),
    value: method,
  })),
});
